<div class="mt-5">
  <canvas id="service-line-chart2" width="439" height="150"></canvas>
</div>
